
import { options } from "../../../pages/reportFolio/pages/timeConfig/utils/constants";
import { TimeItem } from "../../../pages/reportFolio/pages/timeConfig/utils/types";
import { Format } from "../../../utils/types/generals";
import { ServiceLevelByID, ServiceLevelByIdTransform, ServiceTime, ServiceTimeTypes } from "../response/detail";

export const transformById = async ({ response }: { response: ServiceLevelByID }): Format<ServiceLevelByID, ServiceLevelByIdTransform> => {
    const area = response?.area
    const department = response?.department
    const { OLA, SLA, } = separateServcieTimeType({ serviceTime: response?.serviceTimes })
    return {
        data: response,
        item: [],
        format: {
            formTime: {
                maxtime: !!response?.automaticClosing,
                maxtimehour: options.find(time => time.value == response?.timeClosing) ?? options[0],
                ola_switch_firstResponseHours: !!response?.configTimeOla,
                sla_switch_firstResponseHours: !!response?.configTimeSla,
                ola: OLA,
                sla: SLA
            },
            formInputs: {
                register: response?.name,
                areas: { label: area.name, value: area.id.toString(), id: area.id.toString() },
                departments: { label: department.name, value: department.id.toString(), id: department.id.toString() },
                description: response?.description,
                section: response?.serviceLevelConfigCatalogs?.map(catalog => (
                    {
                        label: catalog.catalog?.name ?? "",
                        value: catalog.catalog?.id?.toString(),
                        id: catalog.catalog?.id?.toString()
                    }
                )) || []
            }
        }
    }
}

export const separateServcieTimeType = ({ serviceTime = [] }: { serviceTime?: ServiceTime[] }): Record<ServiceTimeTypes, TimeItem[]> => {
    let body: Record<ServiceTimeTypes, TimeItem[]> = { OLA: [], SLA: [] }

    serviceTime.forEach(service => {
        if (service?.type) {
            body[service.type].push({
                id: service.id,
                days: service.days ?? 0,
                hours: service.hours ?? 0,
                minutes: service.minutes ?? 0,
                seconds: service.seconds ?? 0,
                priorityId: service.priorityId,
            })
        }
    })
    const priorityOrder = [4, 1, 2, 3];

    const sortByCustomPriority = (a: TimeItem, b: TimeItem) =>
        priorityOrder.indexOf(a.priorityId) - priorityOrder.indexOf(b.priorityId);
    return {
        OLA: body.OLA.sort(sortByCustomPriority),
        SLA: body.SLA.sort(sortByCustomPriority),
    };
}